/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IEuiData } from '../../../IEnergyManagementProps';
import { EnergyUsageField } from '../../../../shared/Enums';
import ProgressBarWidget from '../../../../shared/ProgressBar/ProgressBarWidget';
import {
  KPI_PERCENTAGE_DECIMAL_PRECISION,
  KPI_VALUE_DECIMAL_PRECISION
} from '../../../../shared/Utils/Constants';
import {
  getEuiUnitDisplayName,
  handleEuiUnitConversion
} from '../../../../shared/Utils/unitHandling/EuiUnitHandling';

interface IEUITabProps {
  data: IEuiData;
  preferredEuiUnit: string;
}

export const SiteEUIComponent = (props: IEUITabProps) => {
  const { data, preferredEuiUnit } = props;

  const { euiMeasurementUnit, siteWiseCalculation } = data;

  const { actualEui, baselineEui, euiDeviation, euiDeviationPercentage } =
    siteWiseCalculation && siteWiseCalculation[0];

  const aggregationEUITabSite = {
    actual: parseFloat(
      handleEuiUnitConversion(
        actualEui,
        euiMeasurementUnit,
        preferredEuiUnit
      ).toFixed(KPI_VALUE_DECIMAL_PRECISION)
    ),
    previousPeriod: parseFloat(
      handleEuiUnitConversion(
        baselineEui,
        euiMeasurementUnit,
        preferredEuiUnit
      ).toFixed(KPI_VALUE_DECIMAL_PRECISION)
    ),
    savings: parseFloat(
      handleEuiUnitConversion(
        euiDeviation,
        euiMeasurementUnit,
        preferredEuiUnit
      ).toFixed(KPI_VALUE_DECIMAL_PRECISION)
    ),
    savingsPercentage: parseFloat(
      euiDeviationPercentage.toFixed(KPI_PERCENTAGE_DECIMAL_PRECISION)
    )
  };

  return (
    <ProgressBarWidget
      unit={getEuiUnitDisplayName(preferredEuiUnit)}
      category={EnergyUsageField.EUI}
      aggregationData={aggregationEUITabSite}
    />
  );
};
export default SiteEUIComponent;
